/* global google */

/**
 * SnazzyMaps custom style for the map.
 */
const MAP_STYLES = [
	{ featureType: 'all', elementType: 'geometry', stylers: [ { color: '#2b180f' } ] },
	{ featureType: 'all', elementType: 'labels.text.fill', stylers: [ { gamma: 0.01 }, { lightness: 20 } ] },
	{ featureType: 'all', elementType: 'labels.text.stroke', stylers: [ { saturation: -31 }, { lightness: -33 }, { weight: 2 }, { gamma: 0.8 } ] },
	{ featureType: 'all', elementType: 'labels.icon', stylers: [ { visibility: 'off' } ] },
	{ featureType: 'administrative', elementType: 'geometry.fill', stylers: [ { saturation: '17' }, { lightness: '100' }, { gamma: '4.46' } ] },
	{ featureType: 'administrative', elementType: 'labels.text', stylers: [ { color: '#140c08' } ] },
	{ featureType: 'administrative', elementType: 'labels.text.fill', stylers: [ { color: '#ffffff' } ] },
	{ featureType: 'landscape', elementType: 'all', stylers: [ { color: '#a28068' } ] },
	{ featureType: 'landscape', elementType: 'geometry', stylers: [ { lightness: 30 }, { saturation: 30 } ] },
	{ featureType: 'landscape.natural', elementType: 'all', stylers: [ { color: '#6b4828' } ] },
	{ featureType: 'landscape.natural.terrain', elementType: 'all', stylers: [ { color: '#a05f34' } ] },
	{ featureType: 'poi', elementType: 'geometry', stylers: [ { saturation: 20 } ] },
	{ featureType: 'poi.park', elementType: 'geometry', stylers: [ { lightness: 20 }, { saturation: -20 } ] },
	{ featureType: 'poi.park', elementType: 'labels.text', stylers: [ { color: '#ffffff' } ] },
	{ featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [ { color: '#562c46' } ] },
	{ featureType: 'road', elementType: 'geometry', stylers: [ { lightness: 10 }, { saturation: -30 } ] },
	{ featureType: 'road', elementType: 'geometry.stroke', stylers: [ { saturation: 25 }, { lightness: 25 } ] },
	{ featureType: 'road', elementType: 'labels.text.fill', stylers: [ { color: '#e6e6e6' } ] },
	{ featureType: 'road', elementType: 'labels.text.stroke', stylers: [ { color: '#575757' } ] },
	{ featureType: 'water', elementType: 'all', stylers: [ { lightness: -20 }, { color: '#46689d' } ] },
];

/**
 * Initialize a single Google Maps instance.
 *
 * @param {HTMLElement} canvas Map container element.
 */
function initMap( canvas ) {

	const lat = parseFloat( canvas.dataset.lat ) || 49.7186;
	const lng = parseFloat( canvas.dataset.lng ) || 18.8127;
	const zoom = parseInt( canvas.dataset.zoom, 10 ) || 15;
	const markerText = canvas.dataset.marker || '';
	const showGraphicOverlay = canvas.dataset.overlay === '1';
	const center = { lat, lng };

	const mapOptions = {
		center,
		zoom,
		disableDefaultUI: true,
		zoomControl: false,
		mapTypeControl: false,
		streetViewControl: false,
		fullscreenControl: false,
		scrollwheel: false,
		gestureHandling: 'cooperative',
	};

	if ( showGraphicOverlay ) {

		mapOptions.styles = MAP_STYLES;

	}

	const map = new google.maps.Map( canvas, mapOptions );

	const marker = new google.maps.Marker( {
		position: center,
		map,
	} );

	if ( markerText ) {

		const escapedText = markerText
			.replace( /&/g, '&amp;' )
			.replace( /</g, '&lt;' )
			.replace( />/g, '&gt;' )
			.replace( /\n/g, '<br>' );

		const infoWindow = new google.maps.InfoWindow( {
			content: `<div style="color:#2F2B2B;font-family:Lato,sans-serif;padding:0.25rem">${ escapedText }</div>`,
		} );

		marker.addListener( 'click', () => {

			infoWindow.open( map, marker );

		} );

	}

}

/**
 * Initialize all Google Maps blocks on the page.
 */
function initAllMaps() {

	document.querySelectorAll( '.b-google-maps__canvas' ).forEach( ( canvas ) => {

		initMap( canvas );

	} );

}

// Register callback for Google Maps API.
// With loading=async, the google.maps namespace exists early
// but constructors aren't ready until the callback fires.
window.initGoogleMaps = initAllMaps;

// Handle case where API fully loaded before this script ran.
if ( typeof google !== 'undefined' && google.maps && typeof google.maps.Map === 'function' ) {

	initAllMaps();

}
